export const SALIDA = 'S'
export const ENTRADA = 'E'

export const __dictionary = {
  [SALIDA]: {
    id: SALIDA,
    nombre: 'SALIDA'
  },
  [ENTRADA]: {
    id: ENTRADA,
    nombre: 'ENTRADA'
  }
}

export const __array = [__dictionary[SALIDA], __dictionary[ENTRADA]]
